
export type Language = 'en' | 'es' | 'fr' | 'ar' | 'ur' | 'zh' | 'de' | 'it' | 'pt' | 'ru' | 'ja' | 'ko' | 'hi' | 'tr' | 'nl' | 'pl' | 'vi' | 'th' | 'id' | 'el' | 'he' | 'sv' | 'da' | 'no' | 'fi' | 'cs' | 'hu' | 'ro' | 'uk' | 'ms' | 'bn';

export const SUPPORTED_LANGUAGES: { code: Language; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ur', name: 'اردو', flag: '🇵🇰' },
  { code: 'he', name: 'עברית', flag: '🇮🇱' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'bn', name: 'বাংলা', flag: '🇧🇩' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
];

const baseTranslations = {
    "app.name": "Event Manager",
    "landing.hero.title.part1": "Where",
    "landing.hero.title.part2": "Venues",
    "landing.hero.title.part3": "meet",
    "landing.hero.title.part4": "Visions",
    "landing.subtitle": "The perfect platform linking professional Event Businesses with Individuals planning their dream celebration.",
    "landing.services.title": "Our Premier Services",
    "landing.services.subtitle": "Everything you need for an unforgettable event, all in one place.",
    "landing.services.hall": "Hall / Venue Services",
    "landing.services.hall.desc": "Elegant spaces for every occasion, from grand weddings to corporate galas.",
    "landing.services.catering": "Catering Services",
    "landing.services.catering.desc": "Exquisite culinary experiences tailored to your taste and guest count.",
    "landing.services.photo": "Photography / Videography",
    "landing.services.photo.desc": "Capture every precious moment with our professional visual storytellers.",
    "landing.services.transport": "Transportation Services",
    "landing.services.transport.desc": "Seamless and luxury arrival for you and your important guests.",
    "landing.services.deco": "Decoration Services",
    "landing.services.deco.desc": "Stunning floral arrangements and theme-based decor to set the mood.",
    "landing.services.admin": "Administrator can add and manage further customized services.",
    "button.getStarted": "Get Started",
    "button.login": "Login",
    "button.signup": "Sign Up",
    "button.backHome": "Back to Home",
    "login.title": "Event Manager",
    "login.subtitle": "Orchestrate your perfect event",
    "login.business": "Business",
    "login.individual": "Individual",
    "login.email": "Email Address",
    "login.phone": "Mobile Number",
    "login.password": "Password",
    "login.access": "Access Event Portal",
    "login.signin": "Sign in",
    "login.noAccount": "Don't have an account?",
    "signup.title.business": "Create Business Account",
    "signup.title.individual": "Create Individual Account",
    "signup.create": "Create Account",
    "signup.signIn": "Sign in",
    "signup.alreadyAccount": "Already have an account?",
    "signup.country": "Country",
    "signup.fullName": "Full Name",
    "signup.businessName": "Full Business Name",
    "signup.businessType": "Business Type",
    "signup.agree": "I agree to the",
    "signup.terms": "Terms of Service",
    "signup.and": "and",
    "signup.privacy": "Privacy Policy",
    "dashboard.welcome": "Welcome",
    "nav.dashboard": "Dashboard",
    "nav.inquiries": "Inquiries",
    "nav.bookings": "Bookings",
    "nav.vendors": "Vendors",
    "nav.settings": "Settings",
    "nav.logout": "Logout",
    "nav.findVendors": "Find Vendors",
    "nav.gallery": "Gallery",
};

export const translations: Record<Language, Record<string, string>> = {
  en: baseTranslations,
  es: {
    ...baseTranslations,
    "landing.hero.title.part1": "Donde",
    "landing.hero.title.part2": "Lugares",
    "landing.hero.title.part3": "encuentran",
    "landing.hero.title.part4": "Visiones",
  },
  fr: {
    ...baseTranslations,
    "landing.hero.title.part1": "Où",
    "landing.hero.title.part2": "Lieux",
    "landing.hero.title.part3": "rencontrent",
    "landing.hero.title.part4": "Visions",
  },
  de: {
    ...baseTranslations,
  },
  it: {
    ...baseTranslations,
  },
  pt: {
    ...baseTranslations,
  },
  nl: {
    ...baseTranslations,
  },
  ru: {
    ...baseTranslations,
  },
  pl: {
    ...baseTranslations,
  },
  uk: {
    ...baseTranslations,
  },
  cs: {
    ...baseTranslations,
  },
  hu: {
    ...baseTranslations,
  },
  ro: {
    ...baseTranslations,
  },
  sv: {
    ...baseTranslations,
  },
  da: {
    ...baseTranslations,
  },
  no: {
    ...baseTranslations,
  },
  fi: {
    ...baseTranslations,
  },
  el: {
    ...baseTranslations,
  },
  tr: {
    ...baseTranslations,
  },
  ar: {
    ...baseTranslations,
    "landing.hero.title.part1": "حيث تلتقي",
    "landing.hero.title.part2": "القاعات",
    "landing.hero.title.part3": "مع",
    "landing.hero.title.part4": "الرؤى",
    "landing.services.title": "خدماتنا المتميزة",
  },
  ur: {
    ...baseTranslations,
    "landing.hero.title.part1": "جہاں",
    "landing.hero.title.part2": "مقامات",
    "landing.hero.title.part3": "ملتے ہیں",
    "landing.hero.title.part4": "تصورات سے",
    "landing.services.title": "ہماری ممتاز خدمات",
  },
  he: {
    ...baseTranslations,
  },
  hi: {
    ...baseTranslations,
    "landing.hero.title.part1": "जहां",
    "landing.hero.title.part2": "स्थान",
    "landing.hero.title.part3": "मिलते हैं",
    "landing.hero.title.part4": "सपनों से",
    "landing.services.title": "हमारी प्रमुख सेवाएं",
  },
  bn: {
    ...baseTranslations,
  },
  th: {
    ...baseTranslations,
  },
  vi: {
    ...baseTranslations,
  },
  id: {
    ...baseTranslations,
  },
  ms: {
    ...baseTranslations,
  },
  zh: {
    ...baseTranslations,
  },
  ja: {
    ...baseTranslations,
  },
  ko: {
    ...baseTranslations,
  },
};
